/**
 * @classdesc Romanian Language Pack
 * @desc This class will used to translate tokens into the Romanian language.
 * @namespace Languages.Romanian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Romanian
 */
export const dictionary = {
	'years': 'Ani',
	'months': 'Luni',
	'days': 'Zile',
	'hours': 'Ore',
	'minutes': 'Minute',
	'seconds': 'sSecunde'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Romanian
 */
export const aliases = ['ro', 'ro-ro', 'romana'];
